export default __webpack_public_path__ + "media/images/fonts/fontawesome-webfont-a3de2170e4e9df77161ea5d3f31b2668.ttf";